export const START_DATE = 'startDate';
export const START_DATE_INPUT_NAME = 'arrival';
export const END_DATE = 'endDate';
export const END_DATE_INPUT_NAME = 'departure';
export const DATE_FORMAT = 'DD-MM-YYYY';
export const VERTICAL_ORIENTATION = 'vertical';
export const HORIZONTAL_ORIENTATION = 'horizontal';
